import React, { useState, useCallback, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useAlbumStore } from '../../stores/useDataStore';
import ImageUploader from '../common/ImageUploader'; // 🟢 1. Importamos el orquestador
import { uploadImage } from '../../api/media'; // 🟢 2. Importamos la función de subida

const UploadPhotosModal = ({ isOpen, onClose }) => {
  // 🟢 3. Estado para guardar las URLs que nos devuelve el ImageUploader
  const [photoMedia, setPhotoMedia] = useState([]);
  const addPhotosToAlbum = useAlbumStore((state) => state.addPhotosToAlbum);
  const isUploading = useAlbumStore((state) => state.isUploading);
  const uploadProgress = useAlbumStore((state) => state.uploadProgress);

  const resolveUrl = (value) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') return value.url || value.path || value.secure_url || '';
    return '';
  };

  const handleUpload = async () => {
    const photoUrls = (photoMedia || []).map(resolveUrl).filter(Boolean);
    if (photoUrls.length === 0) {
      toast.error('Selecciona al menos una foto para subir.');
      return;
    }
    // 🟢 5. Llamamos a la acción del store con el payload JSON correcto
    const result = await addPhotosToAlbum({
      photoUrls,
      albumType: 'custom',
      albumName: 'Album',
    });
    if (result.success) {
      onClose();
    }
  };

  const handleClose = () => {
    if (isUploading) return;
    setPhotoMedia([]); // Limpiamos el estado al cerrar
    onClose();
  };

  // Limpia los archivos si el modal se cierra desde fuera
  useEffect(() => {
    if (!isOpen) {
      setPhotoMedia([]); // Limpiamos el estado al cerrar
    }
  }, [isOpen]);

  // 🟢 4. El ImageUploader actualiza nuestro estado local
  const handleUploadChange = useCallback((mediaItems) => {
    setPhotoMedia(mediaItems || []);
  }, []);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4"
      onClick={handleClose}
    >
      <div
        className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl flex flex-col overflow-hidden w-full max-w-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Subir Fotos al Álbum</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
          >
            <i className="fas fa-times text-2xl"></i>
          </button>
        </div>

        <div className="p-6 flex-grow overflow-y-auto">
          {/* 🟢 6. Reemplazamos la lógica de dropzone por nuestro orquestador */}
          <ImageUploader
            label="Añadir fotos al álbum"
            uploader={uploadImage}
            onChange={handleUploadChange}
            initialImageUrl={photoMedia}
            multiple={true}
          />
        </div>

        {isUploading && (
          <div className="p-4 border-t border-gray-200 dark:border-gray-700">
            <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
              <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
            </div>
            <p className="text-center text-sm mt-1">{uploadProgress}%</p>
          </div>
        )}

        <div className="p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end">
          <button
            onClick={handleUpload}
            disabled={isUploading || photoMedia.length === 0}
            className="bg-blue-600 text-white font-bold py-2 px-8 rounded-lg hover:bg-blue-700 disabled:bg-blue-400 disabled:cursor-not-allowed transition-colors"
          >
            {isUploading ? (
              <>
                <i className="fas fa-spinner fa-spin mr-2"></i>Subiendo...
              </>
            ) : (
              'Subir Fotos'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadPhotosModal;
